import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        minWidth: '400px',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    amount_row: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: '8px',
        width: '100%',
        marginTop: '16px',
    },
    input: {
        marginTop: '16px',
        width: '100%',
    },
    save_btn: {
        marginTop: '16px',
    },
    collect_all_link: {
        marginBottom: '10px',
        whiteSpace: 'nowrap',
    },
    btn_container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        width: '100%'
    },
    alert: {
        width: '100%',
        marginTop: '10px'
    },
    hint: {
        width: '100%',
        padding: '8px 0',
        textAlign: 'left'
    },
}));

export {useStyles}
